import cfg from 'cfg';
import auth from '../auth';

function checkResponse(res, isOkCb = res => res.json()) {
    if (res.ok) {
        return isOkCb(res);
    } else {
        throw new Error(`${res.status}, ${res.statusText}`);
    }
}

export const fetchUserMe = () =>
    fetch(`${cfg.dash.api.host}/api/v2/me?&access_token=${auth.getAccessToken()}`).then(checkResponse);

export const fetchAllWidgetsSpecs = (template = 'spdk-rlz-superliga-main-test') =>
    fetch(
        `${cfg.dash.api.host}/api/widgets/spec?social=true&template=${template}&access_token=${auth.getAccessToken()}`,
    )
        .then(checkResponse)
        .then(({ widgets = [] }) => widgets);

export const fetchAllTemplatesSpecs = () =>
    fetch(`${cfg.dash.api.host}/api/templates/list?access_token=${auth.getAccessToken()}`).then(res =>
        checkResponse(res, res => res.clone().json()),
    );

export const fetchUserCampaigns = () =>
    fetch(`${cfg.campaign_manager.host}/api/campaigns?access_token=${auth.getAccessToken()}`)
        .then(checkResponse)
        .then(({ campaigns = [] }) => campaigns);

export const putUserCampaignInterests = (campaignId = '', interests = []) =>
    fetch(`${cfg.campaign_manager.host}/api/campaigns/${campaignId}?access_token=${auth.getAccessToken()}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ interests }),
    })
        .then(checkResponse)
        .then(({ campaign = {} }) => campaign);

export const fetchTeamMembers = (teamId = '') =>
    fetch(`${cfg.apis.ss2}/teams/${teamId}/members`)
        .then(checkResponse)
        .then(team => ({ id: teamId, members: team }));

export const fetchTeamEvents = (teamId = '', query = '') =>
    fetch(`${cfg.apis.ss2}/events-v2?teamId=${teamId}&${query}&access_token=${auth.getAccessToken()}`)
        .then(checkResponse)
        .then(({ events = [] }) => events);

export const fetchTournamentsEvents = (ttIds = [], query = '') =>
    fetch(
        `${cfg.apis.ss2}/events-v2?${ttIds
            .map(id => `ttId[]=${id}`)
            .join('&')}&${query}&access_token=${auth.getAccessToken()}`,
    )
        .then(checkResponse)
        .then(({ events = [] }) => events);

export const fetchCampaignRules = (campaignId = '') =>
    fetch(`${cfg.campaign_manager.host}/api/campaigns/${campaignId}/rules?access_token=${auth.getAccessToken()}`)
        .then(checkResponse)
        .then(({ rules = [] }) => rules);

export const postCampaignRule = (campaignId = '', rule) =>
    fetch(`${cfg.campaign_manager.host}/api/campaigns/${campaignId}/rules?access_token=${auth.getAccessToken()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(rule),
    })
        .then(checkResponse)
        .then(({ rule = {} }) => rule);

export const putCampaignRule = (campaignId = '', ruleId, rule) =>
    fetch(
        `${cfg.campaign_manager.host}/api/campaigns/${campaignId}/rules/${ruleId ||
            rule._id}?access_token=${auth.getAccessToken()}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(rule),
        },
    )
        .then(checkResponse)
        .then(({ rule = {} }) => rule);

export const deleteCampaignRule = (campaignId = '', ruleId) =>
    fetch(
        `${
            cfg.campaign_manager.host
        }/api/campaigns/${campaignId}/rules/${ruleId}?access_token=${auth.getAccessToken()}`,
        {
            method: 'DELETE',
        },
    );

// Posts
export const fetchPosts = (query = '') =>
    fetch(`${cfg.campaign_manager.host}/api/posts?${query}&access_token=${auth.getAccessToken()}`)
        .then(checkResponse)
        .then(({ posts = [] }) => posts);

// export const fetchModerationPosts = (campaignId = '', limit = 100) =>
//     fetch(
//         `${
//             cfg.campaign_manager.host
//         }/api/posts?campaignIds=["${campaignId}"]&limit=${limit}&status=awaiting_for_moderation&access_token=${
//             auth.getAccessToken()
//         }`,
//     )
//         .then(checkResponse)
//         .then(({ posts = [] }) => posts);

export const fetchPost = (postId = '') =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}?access_token=${auth.getAccessToken()}`)
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const postNowRule = (campaignId, rule, moderate = true) =>
    fetch(
        `${
            cfg.campaign_manager.host
        }/api/posts/post-to-campaign/${campaignId}?moderate=${moderate}&access_token=${auth.getAccessToken()}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(rule),
        },
    )
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const postUpdatePresentation = (postId = '', widgetName = '', widgetParams = {}) =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}?access_token=${auth.getAccessToken()}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: widgetName, params: widgetParams }),
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const postUpdateMessage = (postId = '', message = '') =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}?access_token=${auth.getAccessToken()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message }),
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const approvePost = postId =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}/approve?access_token=${auth.getAccessToken()}`, {
        method: 'POST',
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const retrySendPost = postId =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}/reset-attempts?access_token=${auth.getAccessToken()}`, {
        method: 'POST',
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const rejectPost = postId =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}/reject?access_token=${auth.getAccessToken()}`, {
        method: 'POST',
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const deletePost = postId =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}/delete?access_token=${auth.getAccessToken()}`, {
        method: 'POST',
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);

export const putChangeTargetsPost = (postId = '', targets = []) =>
    fetch(`${cfg.campaign_manager.host}/api/posts/${postId}/change-targets?access_token=${auth.getAccessToken()}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(targets),
    })
        .then(checkResponse)
        .then(({ post = {} }) => post);
// end Posts

export const fetchSmLinks = () =>
    fetch(`${cfg.apis.smpg}/smlinks?access_token=${auth.getAccessToken()}`).then(checkResponse);

export const fetchPostStats = (publicationIds = []) =>
    fetch(`${cfg.apis.smpg}/stats?resultIds=${JSON.stringify(publicationIds)}`).then(checkResponse);

export const fetchOddsShortenUrl = (url = '', bitlyAccessToken) =>
    fetch(`${cfg.dash.api.host}/api/media/shorten-url?url=${url}&accessToken=${bitlyAccessToken}`).then(checkResponse);

export const fetchSearchPlayers = (searchText = '', signal) =>
    fetch(`${cfg.apis.ss2}/players?q=${searchText}`, signal && { signal }).then(res => res.json());

export const fetchSearchPlayerCareer = (playerId = '', signal) =>
    fetch(`${cfg.apis.ss2}/players/${playerId}/career`, signal && { signal }).then(res => res.json());

export const fetchAllTeams = () => fetch(`${cfg.apis.ss2}/teams`).then(res => res.json());



/** WEBPACK FOOTER **
 ** ../src/dash/front-v2/services/api.js
 **/